<template>
    <!-- ========== TOP MENU ========== -->
    <div class="top_menu" v-bind:class="{ 'transparent hidden-xs' : transparent }">
        <div class="container">
            <div class="welcome_mssg hidden-xs" v-if="!transparent">
                Hotel CEO Group
            </div>
            <ul class="top_menu_right">
                <li>
                    <i class="fa  fa-phone"></i>
                    <a v-bind:href="telefono"> {{ phone }} </a>
                </li>
                <li class="email">
                    <i class="fa  fa-envelope-o "></i>
                    <a v-bind:href="correo">{{ email }}</a>
                </li>
                <li class="language-switcher">
                    <nav class="dropdown">
                        <a href="#" class="dropdown-toggle select" data-hover="dropdown" data-toggle="dropdown" v-if="currentLanguage != null">
                            <i v-bind:class="currentLanguage.icon"></i>
                            {{ tr(currentLanguage.id) }} <b class="caret"></b>
                        </a>
                        <ul class="dropdown-menu">
                            <li v-for="l in languages" :key="l.id">
                                <a href="#" v-on:click.prevent.stop="changeLanguage(l.id)">
                                    <!--<i v-bind:class="l.icon"></i>-->
                                    {{ tr(l.id) }}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import options from '../../config/app';
    import _ from 'lodash';
    export default {
        props: {
            transparent : {
                type : Boolean,
                default : true
            },
        },
        data : function(){
            return {
                phone : null,
                email : null,
                languages : [],
            }
        },
        created : function(){
            let self = this;
            this.phone = options.contact.phone;
            this.email = options.contact.email;
            this.$store.watch( (state) => { return this.$store.getters.languageAvailables; }, (val) => {
                let provisionals = [];
                _.each( self.$store.getters.config.lang, function( value, key ){
                    provisionals.push({
                        id : key,
                        name : value,
                        icon : function(){
                            if( key == 'es')
                            {
                                return 'famfamfam-flag-es';
                            }
                            else if(key == 'en')
                            {
                                return 'famfamfam-flag-us';
                            }
                            else if(key == 'fr')
                            {
                                return 'famfamfam-flag-fr';
                            }
                        }()
                    });
                });
                self.languages = provisionals;
                self.changeLanguage(this.$store.state.language);
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
               self.phone = val.contact.phone;
               self.email = val.contact.email;
            });
        },
        computed : {
            telefono : function(){
                return !_.isEmpty( this.phone ) ? 'tel:'+this.phone : '';
            },
            correo : function(){
                return !_.isEmpty( this.email ) ? 'mailto:'+this.email : '';
            },
            currentLanguage : function(){
                let current = this.$language;
                return _.find( this.languages, function(i){
                   return current == i.id;
                });
            }
        },
        mounted : function(){
            this.changeLanguage(this.$store.state.language);
        },
        methods : {
            tr : function(t){
                return this.translate( this.$language, t);
            },
            changeLanguage : function(lang){
                this.$language = lang;
                this.$emit('change', lang);
                this.$store.commit('lang', lang);
            }
        }
    };
</script>

<style>
    .famfamfam-flag-fr
    {
        background-position: -176px -44px;
    }
</style>


// WEBPACK FOOTER //
// MenuTransparent.vue?974a5a80